import React from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";

import { Button, CircularProgress, Grid, IconButton, Link as MuiLink, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from "@material-ui/core";
import moment from "moment";

import { Column, useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";

import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MuiTable from "@material-ui/core/Table";
import { NotesProjects } from "./NotesProjects";
import { ReportNotes } from "./ReportNotes";
import { NoteViewer } from "./NoteViewer";
import { useReportNotes } from "../../../common/CommonMutations";
import ScreenWidth from "../../../common/ScreenWidth";



export const MovedApproverData = ({ data }: any) => {



    const defaultColumn = useDefaultColumn();
    const theme = useTheme();
    const widthCurrent = ScreenWidth();


    const columns: any[] = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filter: generalFilter,
            },

            {
                id: "Report Type",
                accessor: "report_type_definition_name",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Project Number",
                accessor: "project_number",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>

            },


            {
                id: "Customer",
                accessor: "customer_name",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },


            {
                id: "PM",
                accessor: "project_manager_name",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "NTP",
                accessor: "ntp_date",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "BOM Type",
                accessor: "bom",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },

            {
                id: "Priority",
                accessor: "priority",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Contractually Obligated Date",
                accessor: "contractually_obligated_date",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "Data Ready Date",
                accessor: "ready_datetime",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "Data Verification Date",
                accessor: "data_verification_date",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "PQP Version",
                accessor: "pqp_version",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>

            },
            {
                id: "Tech Writer Start Date",
                accessor: "tech_writer_startdate",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>


            },
            {
                id: "Report Writer Name",
                accessor: "report_writer_name",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>


            },
            {
                id: "Report Reviewer Assigned To",
                accessor: "report_reviewer_name",

                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>

            },

            {
                id: "Link to Finished Report for Review",
                accessor: "report_file",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => {
                    const [loading, setLoading] = React.useState(false);

                    const handleDownload = async () => {
                        setLoading(true);
                        try {
                            const response = await fetch(value, { method: "GET" });
                            if (!response.ok) throw new Error("Failed to download file");

                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.href = url;

                            const filename = value.split("/").pop() || "downloaded_file";
                            a.download = filename;

                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        } catch (error) {
                            console.error("Download error:", error);
                            alert("File could not be downloaded.");
                        } finally {
                            setLoading(false);
                        }
                    };

                    return value ? (
                        <button
                            onClick={handleDownload}
                            style={{
                                color: "#3f51b5",
                                background: "none",
                                border: "none",
                                textDecoration: "underline",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                            }}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="spinner" style={{ fontSize: "12px" }}>
                                    <CircularProgress size={20} />
                                </span>
                            ) : (
                                "View Report"
                            )}
                        </button>
                    ) : (
                        "N/A"
                    );
                },

            },



            {
                id: "notes",
                Header: "Notes",
                disableFilters: true,
                Cell: ({ row }: any) => {
                    const { id, url } = row.original;

                    return <ReportNotes
                        id={id}
                        url={url}
                        type={1}
                        model={"report"}
                        invalidate={[
                            "my_reports",
                            ["reportNotes", row.values.id],
                            "report_Writer",
                        ]}
                        getNotes={useReportNotes}

                    />;
                },
            },
            {
                id: "project_notes",
                Header: "ProjectsNotes",
                disableFilters: true,
                Cell: ({ row }: any) => {
                    const { id, url, project_id } = row.original;

                    return (
                        <>
                            <NotesProjects
                                id={project_id}
                                type={1}

                            />

                        </>
                    )
                },
            },
            {
                id: "add_tasks",
                Header: "AddTasks",
                disableFilters: true,
                Cell: ({ row }: any) => {
                    const { id, url } = row.original;
                    return (
                        <NoteViewer
                            id={id}
                            url={url}
                            type={1}
                            model={"report"}
                            invalidate={[
                                "my_reports",
                                ["reportNotes", row.values.id],
                                "report_Writer",
                            ]}
                            getNotes={useReportNotes}

                        />)
                },
            },
        ],
        []
    );
    const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
        useTable(
            {
                data: data,
                columns,
                defaultColumn,
                initialState: {
                    hiddenColumns: ["id"],

                },
            },
            useFilters,
            useGlobalFilter,
            useSortBy,

        );

    return (

        <TableContainer
            data-testid="tableContainer"
            style={{
                ...theme.tableContainer,
                maxHeight: "500px",
                overflowX: 'auto',
                overflowY: 'auto',
                whiteSpace: 'nowrap',
                maxWidth: `${widthCurrent}px`
            }}
            component={Paper}
        >
            <MuiTable stickyHeader {...getTableProps()} size="small">
                <TableHead>
                    {headerGroups.map((headerGroup) => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <TableCell
                                    style={{
                                        // ...theme.noLeftRightPadding,
                                        width: column.width,
                                        minWidth: column.minWidth,
                                        maxWidth: column.maxWidth,
                                        textAlign: 'center',
                                        padding: "18px",
                                    }}
                                >

                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={0}
                                    >
                                        <Grid item xs={12} {...column.getHeaderProps()}>
                                            <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                spacing={2}
                                            >
                                                <Typography variant="subtitle2">
                                                    {(
                                                        column.id === "notes" ||
                                                        column.id === "project_notes" ||
                                                        column.id === "add_tasks") &&
                                                        column.render("Header")}
                                                </Typography>
                                                {column.canFilter ? column.render("Filter") : null}
                                                {/* <Typography variant="subtitle2">
                                                    {column.render("Header")}
                                                </Typography>

                                                {!(column.id === "notes" || column.id === "add_tasks") && column.canFilter && column.render("Filter")} */}

                                                <Grid item xs={2}>
                                                    <IconButton
                                                        type="submit"
                                                        aria-label="search"
                                                        size="small"
                                                        {...column.getSortByToggleProps()}
                                                    >
                                                        {column.isSorted ? (
                                                            column.isSortedDesc ? (
                                                                <ArrowDropDownIcon />
                                                            ) : (
                                                                <ArrowDropUpIcon />
                                                            )
                                                        ) : (

                                                            column.id !== "notes" &&
                                                            column.id !== "add_tasks" &&
                                                            column.id !== "project_notes" &&
                                                            <CallSplitIcon />
                                                        )}
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableHead>
                <TableBody>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <>
                                <TableRow {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return (
                                            <TableCell {...cell.getCellProps()}
                                                style={{
                                                    width: cell.column.width,
                                                    minWidth: cell.column.minWidth,
                                                    maxWidth: cell.column.maxWidth,
                                                    // padding: "18px",
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>


                            </>
                        );
                    })}
                </TableBody>
            </MuiTable>
        </TableContainer>

    );
};
